import { render } from "./LimitDialogTemplate.vue?vue&type=template&id=2937c194&scoped=true&ts=true"
import script from "./LimitDialogTemplate.vue?vue&type=script&lang=ts"
export * from "./LimitDialogTemplate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2937c194"]])

export default __exports__